import React, { FC } from 'react';

import { Button, Paper, Text, Title } from '@mantine/core';

import { CompanyProfile } from 'models';
import { TeamHelpers } from 'helpers/TeamHelpers';
import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { useCurrentTeam } from 'hooks/use-current-team';
import { useCurrentUser } from 'hooks/use-current-user';
import { useTeam } from 'hooks/use-team';
import { TeamService } from 'services/TeamService';

const SwitchTeamNotice: FC<{
    company: CompanyProfile;
}> = ({ company }) => {
    const user = useCurrentUser();
    const team = useCurrentTeam();

    const { team: companyTeam } = useTeam(company.team);

    const isTeamMember = TeamHelpers.isPartOfTeam(companyTeam, user);
    const isWrongTeam = !CollectionHelpers.equals(team, companyTeam);

    return team && companyTeam && isWrongTeam && isTeamMember ? (
        <Paper w="100%" maw={560} mx="auto" p="xl" radius="md" shadow="lg" withBorder>
            <Title order={2}>Switch to team {companyTeam.name} to manage this profile.</Title>
            <Text mt="sm" mb="sm">
                You are currently logged in to <strong>{team.name}</strong>.<br />
                Switch to <strong>{companyTeam.name}</strong> to manage this profile.
            </Text>
            <Button
                onClick={() => {
                    TeamService.openSwitchTeamModal({
                        create: {
                            title: 'Create Team',
                        },
                        switchy: {
                            title: 'Switch Team',
                        },
                    });
                }}
            >
                Switch team
            </Button>
        </Paper>
    ) : null;
};

export { SwitchTeamNotice };
